import CollapsibleSection from './components/CollapsibleSection';
import parse from 'html-react-parser';
import './scss/Notes.scss';

function Notes({ notes }) {

  return (
    <CollapsibleSection 
      id="notes" 
      name="Notes" 
      defaultCollapsed={true}
      expandedOnDesktop={true}
      card={true}
    >
      <ul className="section-content">
        {notes.map((note, index) =>
          <li key={index}>
            <note-title>{note.title}</note-title>
            <note-text class="textBlock">{parse(note.text)}</note-text>
          </li>
        )}
      </ul>
    </CollapsibleSection>
  );
}

export default Notes;